<template>
  <div class="docsmart_main_dashboard">
    <div class="total_centre">
      <h1 class="mt-2 ml-0 mb-0 text-gray-box">
        Total Users : {{ userData.total_users }}
      </h1>
    </div>
    <v-row class="justify-content-between mb-10 mt-8">
      <v-col cols="6" class="docsmart_user card-box column-width  pt-3">
        <v-row class>
          <v-col cols="3" class="text-center mt-1 pt-0 pr-0">
            <img
              src="/img/avatars/default-user.png"
              alt="default-user"
              class="d-block"
            />
          </v-col>
          <v-col cols="9" class="docsmart_dependents mt-3 mb-3 pb-5 pl-0">
            <h1 class="mb-1 text-dark-fault">
              {{
                userData.docsmart_verified_users +
                  userData.docsmart_verified_users_dependent_count
              }}
            </h1>
            <h2 class="mb-2 text-gray-box">DocSmart Users</h2>
            <h4 class="mb-0 gray-box">
              Including
              {{ userData.docsmart_verified_users_dependent_count }}
              Dependents
            </h4>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6" class="docsmart_user card-box column-width pt-3">
        <v-row>
          <v-col cols="3" class="text-center mt-4 pt-0 pr-0">
            <img
              src="/img/avatars/default-user.png"
              alt="default-user"
              class="d-block"
            />
          </v-col>
          <v-col cols="9" class="docsmart_dependents mt-4 mb-3 pb-5 pl-0">
            <h1 class="mb-1 text-dark-fault">
              {{
                userData.docsmart_non_verified_users +
                  userData.docsmart_non_verified_users_dependent_count
              }}
            </h1>
            <h2 class="mb-2 text-gray-box">Non DocSmart Users</h2>
            <h4 class="gray-box">
              Including
              {{
                userData.docsmart_non_verified_users_dependent_count
              }}
              Dependents
            </h4>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <hr class="w-100 mt-2 mb-2" />
    </v-row>
    <v-row class="mb-10 mt-10">
      <v-col class="col-lg-4 col-sm-6 docsmart_user pl-0 column-width">
        <div class="patientdiv doctordiv pt-3">
          <div class="pl-4 pr-4">
            <h4 class="pb-2 text-dark-fault">
              <b>Total Doctor and Clinics</b>
            </h4>
          </div>
          <v-row class="ml-0 mr-0">
            <hr class="w-100 mb-2 mt-2" />
          </v-row>

          <div>
            <h6 class="mt-0 mb-0 pt-4 pb-3 pl-4 pr-4 text-gray-box">
              Total Clinics: {{ userData.clinics.total }}
            </h6>
          </div>
          <div class="pl-0 pr-4">
            <v-row class="pb-1 row-col">
              <v-col cols="6" class="col-bottom col-mobile mid-col">
                <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                  Active Clinics: {{ userData.clinics.active }}
                </p>
              </v-col>
              <v-col cols="6" class="col-top col-mobile mid-col">
                <!-- <p
              class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
              >Deactivated Clinics: {{userData.clinics.deactive}}  
              </p> -->
                <p
                  class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                >
                  Inactive Clinics: {{ userData.clinics.deactive }}
                </p>
              </v-col>
            </v-row>
          </div>
          <div>
            <v-row class="mt-0 ml-0 mr-0">
              <hr class="w-100 mb-2 mt-2" />
            </v-row>
            <div class="pl-4 pr-4 pt-3">
              <h6 class="mt-2 mb-0 text-gray-box">
                Total Doctors : {{ userData.doctor_status_count.total }}
              </h6>
            </div>
            <div class="pl-0 pr-4 pb-2">
              <v-row class="pb-1 mt-3 row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile mid-col">
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 flex-align gray-box">
                    Approved: {{ userData.doctor_status_count.approved }}
                  </p>
                </v-col>

                <v-col cols="6" class="pt-0 col-top col-mobile mid-col">
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Completed Profiles:
                    {{ userData.completed_roles_count.doctor }}
                  </p>
                </v-col>
              </v-row>
              <v-row class="pb-1 mt-0 row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile mid-col">
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 gray-box">
                    Approval Pending: {{ userData.doctor_status_count.pending }}
                  </p>
                </v-col>
                <v-col cols="6" class="pt-0 col-top col-mobile mid-col">
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Incomplete Profiles:
                    {{ userData.non_completed_roles_count.doctor }}
                  </p>
                </v-col>
              </v-row>
              <v-row class="pb-1 mt-0 row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile mid-col">
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                    Rejected: {{ userData.doctor_status_count.rejected }}
                  </p>
                </v-col>
                <v-col cols="6" class="pt-0 col-top col-mobile mid-col">
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Certificate Not Uploaded:
                    {{ userData.doctor_certificate_not_uploaded }}
                  </p>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-col>
      <v-col
        class="col-lg-4 col-sm-6 pl-8 mob-space docsmart_user patient column-width"
      >
        <div class="patientdiv pt-3">
          <div class="pl-4 pr-4">
            <h4 class="text-dark-fault">
              <b> Patients</b>
            </h4>
          </div>
          <v-row class="ml-0 mr-0">
            <hr class="w-100 mb-2" />
          </v-row>
          <div>
            <h6 class="mt-0 mb-0 pt-4 pb-3 pl-4 pr-4 text-gray-box">
              Total Patients: {{ userData.unique_patient_count.unique_patient }}
            </h6>
          </div>

          <div class="pl-0 pr-4">
            <v-row class="pb-1 row-col">
              <v-col cols="6" class="col-bottom col-mobile mid-col">
                <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                  Completed profiles:
                  {{ userData.unique_patient_count.unique_completed_patient }}
                </p>
              </v-col>
              <v-col cols="6" class="col-top col-mobile mid-col">
                <p
                  class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                >
                  Incomplete profiles:
                  {{
                    userData.unique_patient_count.unique_non_completed_patient
                  }}
                </p></v-col
              >
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <hr class="w-100 mt-0" />
    </v-row>

    <v-row>
      <div class="total_centre mt-10">
        <h1 class="text-gray-box">Total Centre : {{ totalCenter }}</h1>
      </div>
    </v-row>

    <v-row>
      <v-col class="col-lg-4 col-sm-6 col-mobile docsmart_user mt-5 pl-0">
        <div class="patientdiv pt-3">
          <div class="pl-4 pr-4 pb-2">
            <h4 class="text-dark-fault">
              <b>Pharmacy </b>
            </h4>
          </div>
          <v-row class="ml-0 mr-0">
            <hr class="w-100 mb-2 mt-2" />
          </v-row>

          <div>
            <h6 class="mt-0 mb-0 pt-4 pb-3 pl-4 pr-4 text-gray-box">
              Pharmacy Owners: {{ userData.centers_owner_count.pharmacy }}
            </h6>
          </div>

          <div class="pl-0 pr-4">
            <v-row class="pb-1 row-col">
              <v-col cols="6" class="col-bottom col-mobile mid-col">
                <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                  Completed profiles:
                  {{ userData.completed_roles_count.pharmacy }}
                </p>
              </v-col>
              <v-col cols="6" class="col-top col-mobile mid-col">
                <p
                  class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                >
                  Incomplete profiles:
                  {{ userData.non_completed_roles_count.pharmacy }}
                </p></v-col
              >
            </v-row>
          </div>
          <div>
            <v-row class="mt-0 ml-0 mr-0">
              <hr class="w-100 mb-2 mt-2" />
            </v-row>

            <div class="pl-4 pr-4 pt-3">
              <h6 class="mt-2 mb-0 text-gray-box">
                Total Pharmacy Centers : {{ pharmacyData.total }}
              </h6>
            </div>
            <div class="pl-0 pr-4 pb-2">
              <v-row class="pb-1 mt-3 row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile mid-col">
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                    Approved: {{ pharmacyData.approved }}
                  </p>
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                    Approval Pending: {{ pharmacyData.pending }}
                  </p>
                </v-col>
                <v-col cols="6" class="pt-0 col-top col-mobile mid-col">
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Active Centres : {{ pharmacyData.active_centers }}
                  </p>
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Inactive Centres : {{ pharmacyData.deactive_centers }}
                  </p>
                </v-col>
              </v-row>
              <v-row class="pb-1 mt-0 row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile mid-col">
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                    Rejected: {{ pharmacyData.reject }}
                  </p>
                </v-col>
                <v-col cols="6" class="pt-0 col-top col-mobile mid-col">
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Certificate Not Uploaded: {{ pharmacyData.not_uploaded }}
                  </p>
                </v-col>
              </v-row>
              <v-row class="pb-1 mt-0 row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile"> </v-col>
                <v-col cols="6" class="pt-0 col-top col-mobile"> </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-col>
      <v-col
        class="col-lg-4 col-sm-6 pl-8 col-mobile mob-space docsmart_user mt-5 pl-0"
      >
        <div class="patientdiv pt-3">
          <div class="pl-4 pr-4 pb-2">
            <h4 class="text-dark-fault">
              <b>Blood Bank </b>
            </h4>
          </div>
          <v-row class="ml-0 mr-0">
            <hr class="w-100 mb-2 mt-2" />
          </v-row>

          <div>
            <h6 class="mt-0 mb-0 pt-4 pb-3 pl-4 pr-4 text-gray-box">
              Blood Bank Owners: {{ userData.centers_owner_count.bloodbank }}
            </h6>
          </div>

          <div class="pl-0 pr-4">
            <v-row class="pb-1 row-col">
              <v-col cols="6" class="col-bottom col-mobile mid-col">
                <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                  Completed profiles:
                  {{ userData.completed_roles_count.bloodbank }}
                </p>
              </v-col>
              <v-col cols="6" class="col-top col-mobile mid-col">
                <p
                  class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                >
                  Incomplete profiles:
                  {{ userData.non_completed_roles_count.bloodbank }}
                </p></v-col
              >
            </v-row>
          </div>
          <div>
            <v-row class="mt-0 ml-0 mr-0">
              <hr class="w-100 mb-2 mt-2" />
            </v-row>

            <div class="pl-4 pr-4 pt-3">
              <h6 class="mt-2 mb-0 text-gray-box">
                Total Blood Bank Centers : {{ bloodbankData.total }}
              </h6>
            </div>
            <div class="pl-0 pr-4 pb-2">
              <v-row class="pb-1 mt-3 row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile mid-col">
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                    Approved: {{ bloodbankData.approved }}
                  </p>
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                    Approval Pending: {{ bloodbankData.pending }}
                  </p>
                </v-col>
                <v-col cols="6" class="pt-0 col-top col-mobile mid-col">
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Active Centres : {{ bloodbankData.active_centers }}
                  </p>
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Inactive Centres : {{ bloodbankData.deactive_centers }}
                  </p>
                </v-col>
              </v-row>
              <v-row class="pb-1 mt-0 row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile mid-col">
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                    Rejected: {{ bloodbankData.reject }}
                  </p>
                </v-col>
                <v-col cols="6" class="pt-0 col-top col-mobile mid-col">
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right  flex-align gray-box"
                  >
                    Certificate Not Uploaded: {{ bloodbankData.not_uploaded }}
                  </p>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-col>
      <v-col
        class="col-lg-4 col-sm-6 pl-8 col-mobile mob-space docsmart_user add-docsmart  mt-5 pl-0"
      >
        <div class="patientdiv pt-3">
          <div class="pl-4 pr-4 pb-2">
            <h4 class="text-dark-fault">
              <b>Diagnostic </b>
            </h4>
          </div>
          <v-row class="ml-0 mr-0">
            <hr class="w-100 mb-2 mt-2" />
          </v-row>

          <div>
            <h6 class="mt-0 mb-0 pt-4 pb-3 pl-4 pr-4 text-gray-box">
              Diagnostic Owners:
              {{ userData.centers_owner_count["diagnostics-lab"] }}
            </h6>
          </div>

          <div class="pl-0 pr-4">
            <v-row class="pb-1 row-col">
              <v-col cols="6" class="col-bottom col-mobile mid-col">
                <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                  Completed profiles:
                  {{ userData.completed_roles_count["diagnostics-lab"] }}
                </p>
              </v-col>
              <v-col cols="6" class="col-top col-mobile mid-col">
                <p
                  class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                >
                  Incomplete profiles:
                  {{ userData.non_completed_roles_count["diagnostics-lab"] }}
                </p></v-col
              >
            </v-row>
          </div>
          <div>
            <v-row class="mt-0 ml-0 mr-0">
              <hr class="w-100 mb-2 mt-2" />
            </v-row>

            <div class="pl-4 pr-4 pt-3">
              <h6 class="mt-2 mb-0 text-gray-box">
                Total Diagnostic Centers : {{ diagnoData.total }}
              </h6>
            </div>
            <div class="pl-0 pr-4 pb-2">
              <v-row class="pb-1 mt-3  row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile mid-col">
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                    Approved: {{ diagnoData.approved }}
                  </p>
                </v-col>
                <v-col cols="6" class="pt-0 col-top col-mobile mid-col">
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Active Centres : {{ diagnoData.active_centers }}
                  </p>
                </v-col>
              </v-row>
              <v-row class="pb-1 mt-0 row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile mid-col">
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                    Approval Pending: {{ diagnoData.pending }}
                  </p>
                </v-col>
                <v-col cols="6" class="pt-0 col-top col-mobile mid-col">
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Inactive Centres : {{ diagnoData.deactive_centers }}
                  </p>
                </v-col>
              </v-row>
              <v-row class="pb-1 mt-0 row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile mid-col">
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                    Rejected: {{ diagnoData.reject }}
                  </p>
                </v-col>
                <v-col cols="6" class="pt-0 col-top col-mobile mid-col">
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Certificate Not Uploaded: {{ diagnoData.not_uploaded }}
                  </p>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-col>
      <v-col
        class="col-lg-4 col-sm-6 pl-0 col-mobile docsmart_user amb-user mt-5 pl-0"
      >
        <div class="patientdiv pt-3">
          <div class="pl-4 pr-4 pb-2">
            <h4 class="text-dark-fault">
              <b>Ambulance </b>
            </h4>
          </div>
          <v-row class="ml-0 mr-0">
            <hr class="w-100 mb-2 mt-2" />
          </v-row>

          <div>
            <h6 class="mt-0 mb-0 pt-4 pb-3 pl-4 pr-4 text-gray-box">
              Ambulance Owners: {{ userData.centers_owner_count.ambulance }}
            </h6>
          </div>

          <div class="pl-0 pr-4">
            <v-row class="pb-1 row-col">
              <v-col cols="6" class="col-bottom col-mobile mid-col">
                <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                  Completed profiles:
                  {{ userData.completed_roles_count.ambulance }}
                </p>
              </v-col>
              <v-col cols="6" class="col-top col-mobile mid-col">
                <p
                  class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                >
                  Incomplete profiles:
                  {{ userData.non_completed_roles_count.ambulance }}
                </p></v-col
              >
            </v-row>
          </div>
          <div>
            <v-row class="mt-0 ml-0 mr-0">
              <hr class="w-100 mb-2 mt-2" />
            </v-row>

            <div class="pl-4 pr-4 pt-3">
              <h6 class="mt-2 mb-0 text-gray-box">
                Total Ambulance Centers : {{ ambulanceData.total }}
              </h6>
            </div>
            <div class="pl-0 pr-4 pb-2">
              <v-row class="pb-1 mt-3 row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile mid-col">
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                    Approved: {{ ambulanceData.approved }}
                  </p>
                </v-col>
                <v-col cols="6" class="pt-0 col-top col-mobile mid-col">
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Active Centres : {{ ambulanceData.active_centers }}
                  </p>
                </v-col>
              </v-row>
              <v-row class="pb-1 mt-0 row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile mid-col">
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                    Approval Pending: {{ ambulanceData.pending }}
                  </p>
                </v-col>
                <v-col cols="6" class="pt-0 col-top col-mobile mid-col">
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Inactive Centres : {{ ambulanceData.deactive_centers }}
                  </p>
                </v-col>
              </v-row>
              <v-row class="pb-1 mt-0 row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile mid-col">
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                    Rejected: {{ ambulanceData.reject }}
                  </p>
                </v-col>
                <v-col cols="6" class="pt-0 col-top col-mobile mid-col">
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Certificate Not Uploaded: {{ ambulanceData.not_uploaded }}
                  </p>
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-col>
      <v-col
        class="col-lg-4 col-sm-6 pl-8 col-mobile mob-space docsmart_user add-docsmart mt-5 pl-0"
      >
        <div class="patientdiv pt-3">
          <div class="pl-4 pr-4 pb-2">
            <h4 class="text-dark-fault">
              <b>Hospital </b>
            </h4>
          </div>
          <v-row class="ml-0 mr-0">
            <hr class="w-100 mb-2 mt-2" />
          </v-row>

          <div>
            <h6 class="mt-0 mb-0 pt-4 pb-3 pl-4 pr-4 text-gray-box">
              Hospital Owners: {{ userData.centers_owner_count.hospital }}
            </h6>
          </div>

          <div class="pl-0 pr-4">
            <v-row class="pb-1 row-col">
              <v-col cols="6" class="col-bottom col-mobile mid-col">
                <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                  Completed profiles:
                  {{ userData.completed_roles_count.hospital }}
                </p>
              </v-col>
              <v-col cols="6" class="col-top col-mobile mid-col">
                <p
                  class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                >
                  Incomplete profiles:
                  {{ userData.non_completed_roles_count.hospital }}
                </p></v-col
              >
            </v-row>
          </div>
          <div>
            <v-row class="mt-0 ml-0 mr-0">
              <hr class="w-100 mb-2 mt-2" />
            </v-row>

            <div class="pl-4 pr-4 pt-3">
              <h6 class="mt-2 mb-9 text-gray-box"></h6>
            </div>
            <div class="pl-0 pr-4 pb-2">
              <v-row class="pb-1 mt-0 row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile mid-col">
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                    Approved Hospitals: {{ hospitalData.approved }}
                  </p>
                </v-col>
                <v-col cols="6" class="pt-0 col-top col-mobile mid-col">
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Active Hospitals : {{ hospitalData.active_centers }}
                  </p></v-col
                >
              </v-row>
              <v-row class="pb-1 mt-0 row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile mid-col">
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                    Approval Pending: {{ hospitalData.pending }}
                  </p>
                </v-col>
                <v-col cols="6" class="pt-0 col-top col-mobile mid-col">
                  <!-- <p
              class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
              >Deactivated Hospitals : {{ hospitalData.deactive_centers }}
              </p> -->
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Inactive Hospitals : {{ hospitalData.deactive_centers }}
                  </p>
                </v-col>
              </v-row>
              <v-row class="pb-1 mt-0 row-col">
                <v-col cols="6" class="pt-0 col-bottom col-mobile mid-col">
                  <p class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-4 gray-box">
                    Rejected Hospitals: {{ hospitalData.reject }}
                  </p>
                </v-col>
                <v-col cols="6" class="pt-0 col-top col-mobile mid-col">
                  <p
                    class="mt-0 mb-0 pt-0 pb-1 pl-4 pr-2 text-right flex-align gray-box"
                  >
                    Certificate Not Uploaded: {{ hospitalData.not_uploaded }}
                  </p></v-col
                >
              </v-row>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row class="pb-10"> </v-row>
  </div>
</template>
<script>
import config from "@/config.js";
export default {
  data() {
    return {
      totalCenter: null,
      userData: {},
      pharmacyData: {},
      bloodbankData: {},
      diagnoData: {},
      ambulanceData: {},
      hospitalData: {},
    };
  },
  mounted() {
    this.getUserCount();
    this.getPharmacyCount();
    this.getBloodbankCount();
    this.getDiagnoCount();
    this.getAmbulanceCount();
    this.getHospitalCount();
  },
  methods: {
    getUserCount() {
      let url = `${config.BASE_URL}api/v2/admin/admin-profile-count`;
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.userData = response.body.data[0];
        }
      });
    },
    getPharmacyCount() {
      let url = `${config.BASE_URL}api/v2/admin/centers/count/pharmacy`;
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.pharmacyData = response.body.data.data.centerCount;
          this.totalCenter = response.body.data.data.total_center;
        }
      });
    },
    getBloodbankCount() {
      let url = `${config.BASE_URL}api/v2/admin/centers/count/bloodbank`;
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.bloodbankData = response.body.data.data.centerCount;
        }
      });
    },
    getDiagnoCount() {
      let url = `${config.BASE_URL}api/v2/admin/centers/count/diagnostics-lab`;
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.diagnoData = response.body.data.data.centerCount;
        }
      });
    },
    getAmbulanceCount() {
      let url = `${config.BASE_URL}api/v2/admin/centers/count/ambulance`;
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.ambulanceData = response.body.data.data.centerCount;
        }
      });
    },
    getHospitalCount() {
      let url = `${config.BASE_URL}api/v2/admin/centers/count/hospital`;
      this.$http.get(url).then((response) => {
        if (response.body.status) {
          this.hospitalData = response.body.data.data.centerCount;
        }
      });
    },
  },
};
</script>
